import { combineReducers } from "redux";
import document from "./documents";

export default combineReducers({ document });
